module.exports = __webpack_public_path__ + "static/media/locus-logo-dark.0a3c5b6c.png";